const bridge = () => typeof window !== "undefined" ? window.desktopOfflineTables : null;
const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline tables.");
  return api;
};

export const listOfflineTables = (restaurantId) =>
  requireBridge().list({ restaurantId });
export const createOfflineTable = (restaurantId, table) =>
  requireBridge().create({ restaurantId, table });
export const updateOfflineTable = (restaurantId, tableId, table) =>
  requireBridge().update({ restaurantId, tableId, table });
export const deleteOfflineTable = (restaurantId, tableId) =>
  requireBridge().remove({ restaurantId, tableId });
export const listOfflineRunningTables = (restaurantId) =>
  requireBridge().listRunning({ restaurantId });
export const getOfflineRunningTable = (restaurantId, tableKey) =>
  requireBridge().getRunning({ restaurantId, tableKey });
export const saveOfflineRunningTable = (restaurantId, tableKey, order) =>
  requireBridge().saveRunning({ restaurantId, tableKey, order });
export const clearOfflineRunningTable = (restaurantId, tableKey) =>
  requireBridge().clearRunning({ restaurantId, tableKey });
export const clearAllOfflineRunningTables = (restaurantId) =>
  requireBridge().clearAllRunning({ restaurantId });
export const transferOfflineRunningTable = (restaurantId, sourceKey, targetKey, mode) =>
  requireBridge().transferRunning({ restaurantId, sourceKey, targetKey, mode });
